import API from '../index';
import { Address, AddressType, Metadata } from '../../types/common';

export interface AddressResponse {
  street1: string;
  street2: string;
  street3: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  name: string;
  phoneCc: string;
  phone: string;
  countryName?: Record<string, string>;
  type: AddressType;
  metadata: Metadata;
}

export const parseAddress = (res: AddressResponse): Address => ({
  name: res.name,
  phone: res.phone,
  dialCode: res.phoneCc,
  street: [res.street1, res.street2, res.street3].join(' ').trim(),
  city: res.city,
  state: res.state,
  postalCode: res.zip,
  type: res.type,
  metadata: res.metadata,
});

const getAddressHistory = async (countryCode: string): Promise<Address[]> => {
  const { resources } = await API.get(`/customer/addresses/${countryCode}`);
  return resources.map(parseAddress);
};

export default getAddressHistory;
